import React from 'react';
import type { AuthResponseDataScopesInner } from '@seccl/client';

export interface IUserContext {
  scopes?: AuthResponseDataScopesInner[];
  authenticated?: boolean;
  canViewMigrations?: boolean;
}

export const UserContext = React.createContext<IUserContext>({});

export type IUserProviderProps = IUserContext;

export const UserProvider: React.FC<React.PropsWithChildren<IUserProviderProps>> = ({
  scopes,
  authenticated,
  canViewMigrations,
  children,
}) => {
  const value = React.useMemo<IUserContext>(
    () => ({ scopes, authenticated, canViewMigrations }),
    [scopes, authenticated, canViewMigrations]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = (): IUserContext => React.useContext(UserContext);
